import { render, staticRenderFns } from "./GenderChart.vue?vue&type=template&id=5099169c&scoped=true"
import script from "./GenderChart.vue?vue&type=script&lang=js"
export * from "./GenderChart.vue?vue&type=script&lang=js"
import style0 from "./GenderChart.vue?vue&type=style&index=0&id=5099169c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5099169c",
  null
  
)

export default component.exports